export default __webpack_public_path__ + "static/media/magnifyicon_hover.cbff2984.png";